import { DomainsApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const domainsApi = DomainsApi({}, '/api', axiosInstance);
